/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Sheet_EmptyInputs */

const en_us2_offline_sheet_empty = /** @type {(inputs: Offline_Sheet_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Everything is synced.`)
};

const pt_br2_offline_sheet_empty = /** @type {(inputs: Offline_Sheet_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tudo sincronizado.`)
};

const es_419_offline_sheet_empty = /** @type {(inputs: Offline_Sheet_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todo está sincronizado.`)
};

const pt_pt2_offline_sheet_empty = /** @type {(inputs: Offline_Sheet_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tudo sincronizado.`)
};

const fr_fr2_offline_sheet_empty = /** @type {(inputs: Offline_Sheet_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tout est synchronisé.`)
};

const de_de2_offline_sheet_empty = /** @type {(inputs: Offline_Sheet_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alles synchronisiert.`)
};

const it_it2_offline_sheet_empty = /** @type {(inputs: Offline_Sheet_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutto sincronizzato.`)
};

/**
* | output |
* | --- |
* | "Everything is synced." |
*
* @param {Offline_Sheet_EmptyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const offline_sheet_empty = /** @type {((inputs?: Offline_Sheet_EmptyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Sheet_EmptyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_offline_sheet_empty(inputs)
	if (locale === "es-419") return es_419_offline_sheet_empty(inputs)
	if (locale === "pt-PT") return pt_pt2_offline_sheet_empty(inputs)
	if (locale === "fr-FR") return fr_fr2_offline_sheet_empty(inputs)
	if (locale === "de-DE") return de_de2_offline_sheet_empty(inputs)
	if (locale === "it-IT") return it_it2_offline_sheet_empty(inputs)
	return en_us2_offline_sheet_empty(inputs)
});
export { offline_sheet_empty as "offline.sheet_empty" }